/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestDetectTripsByUsernameAndTransports } from '../model/models';
import { Trip } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TripDetectionServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param username 
     * @param apiRequestDetectTripsByUsernameAndTransports 
     */
    tripDetectionControllerByTransportsAndUsername0(username: string, apiRequestDetectTripsByUsernameAndTransports: ApiRequestDetectTripsByUsernameAndTransports, extraHttpRequestParams?: any): Observable<Array<Trip>>;

    /**
     * 
     * 
     * @param username 
     * @param apiRequestDetectTripsByUsernameAndTransports 
     */
    tripDetectionControllerByTransportsAndUsername1(username: string, apiRequestDetectTripsByUsernameAndTransports: ApiRequestDetectTripsByUsernameAndTransports, extraHttpRequestParams?: any): Observable<Array<Trip>>;

}
